import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ShieldCheck, ArrowUpRight } from 'lucide-react';
import { AnimatedIcon } from './AnimatedIcon';

const FdaTrustBar = () => {
  const dark = true;

  return (
    <section
      data-testid="fda-trust-bar"
      className={`relative border-y ${dark ? 'border-white/10 bg-[#04101f]' : 'border-slate-200 bg-[#f3f7fc]'}`}
    >
      <div className="pointer-events-none absolute left-0 top-0 h-px w-full bg-gradient-to-r from-blue-500/50 via-[#E87A20]/40 to-transparent" />
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-60px' }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="mx-auto max-w-6xl px-4 py-7 md:px-12 md:py-8 lg:px-24"
      >
        <div className="flex flex-col gap-4 md:flex-row md:items-center md:gap-6">
          <div className="flex h-11 w-11 flex-shrink-0 items-center justify-center bg-blue-600 text-white">
            <AnimatedIcon><ShieldCheck className="h-6 w-6" strokeWidth={1.8} /></AnimatedIcon>
          </div>
          <p className={`text-sm leading-relaxed md:text-[15px] ${dark ? 'text-slate-200' : 'text-slate-700'}`}>
            Officially registered with the{' '}
            <strong className={dark ? 'text-white' : 'text-slate-900'}>Philippines Food and Drug Administration</strong>{' '}
            (Ortho:{' '}
            <span className="font-mono text-xs font-bold text-blue-500" data-testid="fda-ortho-code">CMDR-2025-04943A</span>{' '}
            | Dent:{' '}
            <span className="font-mono text-xs font-bold text-blue-500" data-testid="fda-dent-code">CMDR-2025-04943B</span>).
            Exclusively distributed nationwide by{' '}
            <strong className={dark ? 'text-white' : 'text-slate-900'}>Fortschritt Medical Supplies Inc.</strong>
          </p>
        </div>

        {/* Interactive trust link → eGov verification */}
        <div className={`mt-5 flex flex-col gap-3 border-t pt-5 sm:flex-row sm:items-center sm:justify-between ${dark ? 'border-white/10' : 'border-slate-200'}`}>
          <p className={`text-sm leading-relaxed ${dark ? 'text-slate-400' : 'text-slate-600'}`}>
            Having second thoughts on material safety and reliability? The Philippines Food and Drug Administration
            completely vouches for our compliance.
          </p>
          <Link
            to="/fda-verification"
            data-testid="fda-verify-link"
            className="group inline-flex flex-shrink-0 items-center gap-2 bg-blue-600 px-5 py-2.5 text-sm font-bold text-white transition-all duration-300 hover:bg-blue-500 hover:shadow-[0_0_30px_rgba(37,99,235,0.4)]"
          >
            Verify our institutional credentials
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={2.2} />
          </Link>
        </div>
      </motion.div>
    </section>
  );
};

export default FdaTrustBar;
